import React, { useState } from 'react';
import useWizard from '../Hooks/useWizard';
import { WizardAction } from '../Interfaces/Wizard.interface';
import Loading from '../../BaseModule/Components/Loading';
import { normalizeWizardFormValues } from '../Helpers/WizardValues.helper';
import WizardRender from './WizardRender/WizardRender';

interface Props {
	wizardKey: string;
	initialData?: object;
	keepInitialData?: boolean;
	onWizardDone: (action: WizardAction) => void;
	keepStepsData?: boolean;
	wizardTitleStyle?: React.CSSProperties;
	wizardDescriptionStyle?: React.CSSProperties;
}

const Wizard: React.FC<Props> = ({
	wizardKey,
	initialData,
	keepInitialData,
	onWizardDone,
	keepStepsData,
	wizardTitleStyle,
	wizardDescriptionStyle,
}) => {
	const [stepsData, setStepsData] = useState<object>({});
	const { activeStep, submitStep, isLoading } = useWizard({
		key: wizardKey,
		initialData,
		onWizardDone,
	});

	const handleSubmit = async (values: object) => {
		const normalized = normalizeWizardFormValues(values);

		if (keepStepsData) {
			setStepsData(prevState => ({
				...prevState,
				...normalized,
			}));
		}

		await submitStep({
			...stepsData,
			...normalized,
			...(keepInitialData ? initialData : {}),
		});
	};

	if (!activeStep || isLoading) {
		return (
			<div className='d-flex justify-content-center'>
				<Loading purple />
			</div>
		);
	}

	return (
		<WizardRender
			activeStep={activeStep}
			wizardTitleStyle={wizardTitleStyle}
			wizardDescriptionStyle={wizardDescriptionStyle}
			onSubmit={handleSubmit}
		/>
	);
};

export default Wizard;
